module.exports = __webpack_public_path__ + "media/packs/images/notification/update-read-948599cec6723b1150ce08eaef8557c4.svg";